import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtProjectGroup } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadProjectGroupById,
    setProjectGroupEdit,
    setProjectGroupReloadEdit,
    initProjectGroup,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface EditGroupProps {
    groupData: MtProjectGroup
}

const EditDefaultGroup = ({
    groupData,
}: EditGroupProps) => {
    const group = useSelector((state: StoreType) => state.projectGroup.groupEdit)
    const reloadEdit = useSelector((state: StoreType) => state.projectGroup.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const { groupId, accountId, projectId } = groupData || {}

    const reload = () => {
        dispatch(setProjectGroupReloadEdit(false))
        setTimeout(() => {
            dispatch(setProjectGroupReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (!groupId) {
            dispatch(setProjectGroupEdit(initProjectGroup))
            reload()
        } else {
            setLoadState(PENDING)
            LoadProjectGroupById(groupId, accountId, projectId).then((res) => {
                dispatch(setProjectGroupEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    const readOnly = group.default && userData.accountId !== 1
    const pageHeader = !group.groupId
        ? lang.addGroup
        : readOnly
            ? `${lang.viewGroup} # ${group.groupId}`
            : `${lang.editGroup} # ${group.groupId}`

    if (!group) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{pageHeader}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form group={group} readOnly={readOnly} />
                }
                {
                    reloadEdit
                    && <Form group={group} readOnly={readOnly} />
                }
            </PageContent>
        </Container>
    )
}
export default EditDefaultGroup
